// Bootstrap 5 Modal Utilities
// Provides compatibility functions for migrating from Bootstrap 4 jQuery modal syntax

/**
 * Show a modal using Bootstrap 5 API
 * @param {string|Element} element - Modal element or selector
 * @param {Object} options - Modal options
 */
export const showModal = (element, options = {}) => {
  const modalElement = typeof element === 'string' ? document.querySelector(element) : element;
  if (!modalElement) {
    console.warn('Modal element not found:', element);
    return null;
  }
  
  const modal = new bootstrap.Modal(modalElement, options);
  modal.show();
  return modal;
};

/**
 * Hide a modal using Bootstrap 5 API
 * @param {string|Element} element - Modal element or selector
 */
export const hideModal = (element) => {
  const modalElement = typeof element === 'string' ? document.querySelector(element) : element;
  if (!modalElement) {
    console.warn('Modal element not found:', element);
    return null;
  }
  
  const modal = bootstrap.Modal.getInstance(modalElement);
  if (modal) {
    modal.hide();
  } else {
    // If no instance exists, create one and hide it
    const newModal = new bootstrap.Modal(modalElement);
    newModal.hide();
  }
  return modal;
};

/**
 * Toggle a modal using Bootstrap 5 API
 * @param {string|Element} element - Modal element or selector
 * @param {Object} options - Modal options
 */
export const toggleModal = (element, options = {}) => {
  const modalElement = typeof element === 'string' ? document.querySelector(element) : element;
  if (!modalElement) {
    console.warn('Modal element not found:', element);
    return null;
  }
  
  let modal = bootstrap.Modal.getInstance(modalElement);
  if (!modal) {
    modal = new bootstrap.Modal(modalElement, options);
  }
  modal.toggle();
  return modal;
};

/**
 * Get modal instance
 * @param {string|Element} element - Modal element or selector
 */
export const getModalInstance = (element) => {
  const modalElement = typeof element === 'string' ? document.querySelector(element) : element;
  if (!modalElement) {
    console.warn('Modal element not found:', element);
    return null;
  }
  
  return bootstrap.Modal.getInstance(modalElement);
};

/**
 * Add event listener to modal
 * @param {string|Element} element - Modal element or selector
 * @param {string} event - Event name (e.g., 'show.bs.modal', 'hide.bs.modal')
 * @param {Function} callback - Event callback
 */
export const onModalEvent = (element, event, callback) => {
  const modalElement = typeof element === 'string' ? document.querySelector(element) : element;
  if (!modalElement) {
    console.warn('Modal element not found:', element);
    return;
  }
  
  modalElement.addEventListener(event, callback);
};

// jQuery-like compatibility functions for easier migration
window.showModal = showModal;
window.hideModal = hideModal;
window.toggleModal = toggleModal;
window.getModalInstance = getModalInstance;
window.onModalEvent = onModalEvent;
